var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.textArr.length)?_c('div',{staticClass:"textBox"},[_c('div',{staticClass:"line"}),_vm._v(" "),_c('transition',{attrs:{"name":"slide"}},[_c('p',{key:_vm.text.id,staticClass:"text",on:{"click":function($event){return _vm.openNew(_vm.text.id)}}},[_vm._v(_vm._s(_vm.text.title))])])],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5935f4d9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Notice.vue
// module id = null
// module chunks = 